import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
type DefaultType = 'configuration' | 'ruleset';

@Component({
	selector: 'app-defults-rules-dialog-box',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './defults-rules-dialog-box.component.html',
	styleUrl: './defults-rules-dialog-box.component.scss'
})
export class DefultsRulesDialogBoxComponent {

	constructor(
		private dialogRef: MatDialogRef<DefultsRulesDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { type: DefaultType }
	) { }


	confirm(): void {
		this.dialogRef.close(true);
	}


	cancel(): void {
		this.dialogRef.close(false);
	}

}
